import Dialog from '@mui/material/Dialog'

import type { Gebied } from '@models/Gebied'

import type { ActiviteitTemplate } from '../../../../templates/types/ActiviteitTemplate'
import type { Project } from '../../types/Project'
import { Actief } from '../dialogs/Actief'
import { CombiUitvoering } from '../dialogs/CombiUitvoering'
import { Gebiedswissel } from '../dialogs/Gebiedswissel'
import { Herplan } from '../dialogs/Herplan'
import { Labels } from '../dialogs/Labels'
import { Quickscan } from '../dialogs/Quickscan'

interface Props {
  open: boolean
  type?: string
  project: Project
  onClose: () => void
  gebieden: Gebied[]
  activiteitTemplates: ActiviteitTemplate[]
  selectableLabels: string[]
}

export const ProjectOptionsDialog = ({
  open,
  type,
  project,
  onClose,
  gebieden,
  activiteitTemplates,
  selectableLabels,
}: Props) => {
  if (!type || !project) return null

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      {type === 'combiuitvoering' && (
        <CombiUitvoering project={project} handleClose={onClose} />
      )}

      {type === 'quickscan' && (
        <Quickscan
          project={project}
          handleClose={onClose}
          activiteitTemplates={activiteitTemplates}
        />
      )}

      {type === 'actief' && <Actief project={project} handleClose={onClose} />}

      {type === 'labels' && (
        <Labels
          project={project}
          selectableLabels={selectableLabels}
          handleClose={onClose}
        />
      )}

      {type === 'herplanning_klant' && (
        <Herplan project={project} handleClose={onClose} />
      )}

      {type === 'gebiedswissel' && (
        <Gebiedswissel
          project={project}
          handleClose={onClose}
          gebieden={gebieden}
        />
      )}
    </Dialog>
  )
}
